import { ProtectedAPIList as ConfigProtectedAPIList } from "./constants";

/**
 * Check if an API call requires Turnstile token protection
 * Uses the ProtectedAPIList from constants.ts
 */
export const isProtectedAPI = (url: string, method: string): boolean => {
  return ConfigProtectedAPIList.some(
    (api) =>
      url.toLowerCase().includes(api.url.toLowerCase()) &&
      api.method.toUpperCase() === method.toUpperCase()
  );
};
